(() => {
  const englishMessage = (field) => {
    const validity = field.validity;
    const label = field.labels?.[0]?.textContent?.trim().replace(/\s+/g, ' ') || 'This field';

    if (validity.valueMissing) {
      if (field.type === 'checkbox') return 'Please confirm this option.';
      if (field.type === 'radio') return 'Please select an option.';
      return `${label} is required.`;
    }
    if (validity.typeMismatch && field.type === 'email') {
      return 'Please enter a valid email address, including the @ symbol.';
    }
    if (validity.typeMismatch && field.type === 'url') {
      return 'Please enter a valid URL, including https://';
    }
    if (validity.patternMismatch) return 'Please match the requested format.';
    if (validity.tooShort) return `Please enter at least ${field.minLength} characters.`;
    if (validity.tooLong) return `Please enter no more than ${field.maxLength} characters.`;
    if (validity.rangeUnderflow) return `Please enter a value of ${field.min} or higher.`;
    if (validity.rangeOverflow) return `Please enter a value of ${field.max} or lower.`;
    if (validity.stepMismatch) return 'Please enter a valid value.';
    if (validity.badInput) return 'Please enter a valid value.';
    return 'Please check this field.';
  };

  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;
    field.setCustomValidity('');
    if (!field.validity.valid) field.setCustomValidity(englishMessage(field));
  }, true);

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  }, true);

  document.addEventListener('change', (event) => {
    const field = event.target;
    if (typeof field.setCustomValidity === 'function') field.setCustomValidity('');
  }, true);
})();
